import { render, staticRenderFns } from "./Tax.vue?vue&type=template&id=5b27a4b8"
import script from "./Tax.vue?vue&type=script&lang=js"
export * from "./Tax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b27a4b8')) {
      api.createRecord('5b27a4b8', component.options)
    } else {
      api.reload('5b27a4b8', component.options)
    }
    module.hot.accept("./Tax.vue?vue&type=template&id=5b27a4b8", function () {
      api.rerender('5b27a4b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/estimates/Tax.vue"
export default component.exports